import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  TRADED_VOLUME_BUCKETS,
  buildBucketPerformance,
  getTradeTradedQuantity,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceByVolumeTradedWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceByVolumeTradedWidget: React.FC<PerformanceByVolumeTradedWidgetProps> = ({
  timeRange, 
  size,
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: TRADED_VOLUME_BUCKETS, metric: getTradeTradedQuantity }),
    [timeRange, trades]
  );

  return <BucketPerformanceList result={perfData} size={size} pctFormatter={(item) => `${item.pct.toFixed(item.pct < 1 ? 2 : 1)}%`} />;
};